<template>
  <div v-if="currentFilter" class="pa-2">
    <div>
      <div>
        {{ $t('sort_by') }}
        <DropdownMenu
          v-model="currentFilter.sortBy"
          :options="optionsSort"
          :outtericon="true"
          :text-label="'label'"
          :text-value="'value'"
          @change="onSearch"
        >
          <span style="font-weight: bold">{{ sortByLabel }}</span>
        </DropdownMenu>
      </div>
    </div>
    <v-divider class="my-2"></v-divider>
    <template v-if="!isDisabledChannelFilter">
      <div>{{ $t('channel') }}</div>
      <div>
        <v-radio-group v-model="currentFilter.channel" class="mt-0" row @change="onSearch">
          <v-radio :label="$t('all')" color="primary" value="all"></v-radio>
          <template v-for="channel in conversationSocialChannelOptions">
            <v-radio
              :key="channel.fullValueForUse"
              :label="channel.text"
              :value="channel.fullValueForUse"
              color="primary"
            ></v-radio>
          </template>
        </v-radio-group>
      </div>
    </template>

    <div>{{ $t('priority') }}</div>
    <div>
      <v-combobox
        v-model="currentFilter.priority"
        :items="priorityOptions"
        :placeholder="$t('priority')"
        :return-object="false"
        chips
        hide-details
        item-text="label"
        item-value="value"
        multiple
        outline
        single-line
        @input="onSearch"
      >
      </v-combobox>
    </div>

    <div class="mt-3">{{ $t('status') }}</div>
    <div>
      <v-combobox
        v-model="filterStatus"
        :items="statusOptions"
        :placeholder="$t('status')"
        chips
        hide-details
        item-text="label"
        item-value="value"
        multiple
        outline
        single-line
        @input="onSearch"
      >
      </v-combobox>
    </div>

    <template v-if="wrapUpOptions">
      <div class="mt-3">{{ $t('wrap_up') }}</div>
      <div>
        <v-combobox
          v-model="currentFilter.wrap_up"
          :items="wrapUpOptions"
          :placeholder="$t('wrap_up')"
          chips
          hide-details
          item-text="label"
          item-value="value"
          multiple
          outline
          single-line
          @input="onSearch"
        >
        </v-combobox>
      </div>
    </template>
  </div>
</template>

<script>
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import { priorityOptions } from '@/constants/ticket3/ticketConstant'
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
import { PAGE_GROUP } from '@/constants/page.js'
import { ADMIN_SHOW_FACEBOOK_ONLY } from '../../../../constants/cimb_wealth'

export default {
  components: {
    DropdownMenu
  },
  props: ['filter'],
  data() {
    return {
      currentFilter: undefined,
      priorityOptions: priorityOptions,
      optionsSort: [
        { label: this.$t('assign_ticket_timestamp'), value: 'assign_ticket_timestamp' },
        { label: this.$t('due_by_time'), value: 'duedate' },
        { label: this.$t('created_date'), value: 'starttime' },
        { label: this.$t('priority'), value: 'priority' }
      ],
      loading: false,
      wrapUpOptions: undefined
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCustomerSupportService', 'customerStatusOptions']),
    sortByLabel() {
      const sortBy =
        this.optionsSort && this.optionsSort.find((el) => el.value == this.filter.sortBy)
      return sortBy ? sortBy.label : null
    },
    statusOptions() {
      if (this.isCustomerSupportService) {
        return this.customerStatusOptions.map((option) => {
          return { ...option, label: this.$t(`ticket_status.${option.value}`) }
        })
      } else {
        const status = this.$store.getters.ticketStatusOptions
        if ([PAGE_GROUP.EMMA_CLINIC].includes(this.selectedBot.page_group)) {
          const statusFilter = status.filter((item) =>
            ['pending', 'answered', 'cancelled', 'cancelled by customer'].includes(item.value)
          )
          const index = 2
          const statusOption = [
            ...statusFilter.slice(0, index),
            { label: 'closed', value: 'closed without survey', color: '#e0e0e0' },
            ...statusFilter.slice(index)
          ]
          return statusOption.map((option) => {
            return { ...option, label: this.$t(`ticket_status.${option.value}`) }
          })
        } else {
          return status.map((option) => {
            return { ...option, label: this.$t(`ticket_status.${option.value}`) }
          })
        }
      }
    },
    filterStatus: {
      get() {
        const status = this.filter && this.filter.status ? this.filter.status : []
        return this.statusOptions.filter((el) => status.includes(el.value))
      },
      set(value) {
        this.currentFilter.status = value ? value.map((el) => el.value.toLowerCase()) : []
      }
    },
    bypassCIMBAdminShowFacebookOnly() {
      return (
        [PAGE_GROUP.CIMB_WEALTH].includes(this.selectedBot.page_group) &&
        ADMIN_SHOW_FACEBOOK_ONLY.includes(this.$store.state.userid)
      )
    },
    isDisabledChannelFilter() {
      return this.bypassCIMBAdminShowFacebookOnly
    }
  },
  watch: {
    filter: {
      handler(val) {
        this.currentFilter = val
      },
      deep: true
    }
  },
  mounted() {
    this.currentFilter = this.filter
    this.getWrapUp()
  },
  methods: {
    onSearch() {
      this.$emit('onSearch', this.filter)
    },
    async getWrapUp() {
      this.loading = true
      try {
        const response = await this.$store.dispatch('loadWrapUp', {
          page_id: this.selectedBot.pageid
        })
        if (response) {
          this.wrapUpOptions = response.data
            ? response.data.map((el) => ({
                label: el.wrap_up,
                value: el.wrap_up
              }))
            : []
          this.total = +response.total || 0
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketFilter.vue